import React from "react";

interface TableRow {
  title: string;
  premium: boolean;
  alternating: boolean;
}

interface ComparisonTableProps {
  className?: string;
  rows: TableRow[],
}

const ComparisonTable: React.FC<ComparisonTableProps> = ({
  className,
  rows,
}: ComparisonTableProps) => (
  <table className={`table comparison-table ${className}`}>
    <thead>
      <tr className="comparison-table-header">
        <td scope="col" className="text-center">
          <b className="gotham-bold">NOTE:</b> Alternating Package rotates between
          Premium and Touch-Up cleaning services
        </td>
        <td scope="col" className="text-center comparison-table-premium-title">
          <b className="gotham-bold"><i>MOST POPULAR</i></b>
          <br />
          Premium
          <br />
          Services Include
        </td>
        <td scope="col" className="text-center">
          Alternating
          <br />
          Touch-Up services include
        </td>
      </tr>
    </thead>
    <tbody>
      {
        rows.map((element, index) =>
          <tr key={index} className={index % 2 ? "comparison-table-pink-bg" : ""}>
            <td scope="col">
              {element.title}
            </td>
            <td scope="col" align="center" className="comparison-table-premium">
              {element.premium && <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955997/hubsite-reskin/New%20Services%20Pages/white-checkmark.webp" />}
            </td>
            <td scope="col" align="center">
              {element.alternating && <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955995/hubsite-reskin/New%20Services%20Pages/pink-checkmark.webp" />}
            </td>
          </tr>
        )
      }
    </tbody>
  </table>
);

ComparisonTable.defaultProps = {
  className: "",
};

export default ComparisonTable;
